import type { ResolvedEdit, SourcePack } from "@desk/core";
import { editTickToSourceTick, type EditedTimeline } from "./timeline.js";

/**
 * The beat the Focus tool (and the on-video pan surface) currently act on: the
 * retained beat under the playhead, falling back to the first retained beat.
 * Shared by FrameTool (zoom control) and EditorScreen (drag-to-pan) so both
 * edit the SAME beat's frame crop without drifting.
 */
export function focusBeatId(
  resolved: ResolvedEdit,
  timeline: EditedTimeline,
  tick: number,
  pack: SourcePack,
): string {
  const retained = resolved.beatOrder.filter(
    (id) => resolved.cuts.get(id)?.mode !== "omit",
  );
  const fallback = retained[0] ?? pack.beats[0]?.id ?? "";
  if (timeline.durationTicks === 0) return fallback;
  const sourceTick = editTickToSourceTick(timeline, tick);
  const hit = timeline.segments.find(
    (s) => sourceTick >= s.sourceStartTick && sourceTick < s.sourceEndTick,
  );
  if (hit && retained.includes(hit.beatId)) return hit.beatId;
  return fallback;
}
